import React from 'react';
import './AdminNavbar.css';

const AdminNavbar = ({ 
  onLogout, 
  searchTerm, 
  setSearchTerm, 
  statusFilter, 
  setStatusFilter,
  levelFilter,
  setLevelFilter,
  totalApplications,
  filteredApplications 
}) => {
  return (
    <nav className="admin-navbar">
      <div className="admin-navbar-header">
        <h1>AAS Admin Dashboard</h1>
        <div className="admin-stats">
          <span>Total: {totalApplications}</span>
          <span>Filtered: {filteredApplications}</span>
        </div>
      </div>
      
      <div className="admin-navbar-controls">
        <div className="search-section">
          <input
            type="text"
            placeholder="Search by name, email, course, or application ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        
        <div className="filter-section">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="status-filter"
          >
            <option value="all">All Status</option>
            {/* <option value="not submited">Not Submitted</option> */}
            <option value="submitted">Submitted</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
            <option value="selected">Selected</option>
          </select>
        </div>
        
        <div className="filter-section">
          <select
            value={levelFilter}
            onChange={(e) => setLevelFilter(e.target.value)}
            className="level-filter"
          >
            <option value="all">All Levels</option>
            <option value="degree">Degree</option>
            <option value="masters">Masters</option>
            {/* <option value="phd">PhD</option> */}
            {/* <option value="diploma">Diploma</option> */}
            {/* <option value="certificate">Certificate</option> */}
            {/* <option value="certificate">Certificate</option> */}
          </select>
        </div>
        
        <div className="logout-section">
          <button onClick={onLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar; 